import { useTranslation } from 'react-i18next';
import React, { useContext, useState, useEffect } from "react"
import TopSearch from "@/components/TopSearch"
import ListComponent from "@/components/listComponent"
import { transferDataMonitor, transferDataMonitorExport,transferDataMonitorTotal } from "@/service/statistics"
import { MyContext } from "@/store/myContext"
import moment from "moment"
import { message,Tooltip,Table,Button } from "antd"
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel";
import { formatNum } from '@/erp_subpackage/utils/util';
import useGlobalModel from "@/erp_subpackage/model/globalModel";
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum"
import { YhBox } from "@/erp_subpackage/components/YhBox";
import YhTooltip from "@/erp_subpackage/components/YhTooltip"
import { convertRes2Blob } from "@/erp_subpackage/utils/exportFile";
import { getCurrentCurrencySymbol } from '@/utils/currencyUtils';

export default () => {
    
const { t } = useTranslation();
const { state,Option } = useContext(MyContext)
    const [list, setList] = useState([]) //列表
    const [totalData, setotalData] = useState({}) //总计
    const [shopList, setShopList] = useState([])
    const { user: { shopId, shopCode, shopName, organType, orgCode, orgName },fetchFmsShopList,setLoadingInfo } = useGlobalModel()
    const [searchValue, setSearchValue] = useState({})
    const { getSelectedDictOne, getTreeNodeName } = useDictModel(() => []);
    const [pagination, setpagination] = useState({
        //分页配置
        total: 0,
        current: 1,
        pageSize: 10,
    })
    const [selectInfo, setSelectInfo] = useState({ rowInfo: {}, rowIndex: -1 }) //记录当前行下标及信息
    const [loading, setLoading] = useState(false)
    //副标题计算
    useEffect(() => {
        if (state.activeMenu === "transferDataMonitor") {
            loadData(pagination.current)
        }

    }, [state.activeMenu]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        fetchFmsShopList('').then(arr => {
            setShopList(arr)  
        })
    }, [])
    //列表数据
    const loadData = (current, search = searchValue) => {
        setLoading(true)
        let data = {
             ...search,
            pageNum: current,
            pageSize: search?.pageSize??10,
            shopCode,
            shopId,
            branchIn: "ci",
            branchOut: "ci"
            }
        transferDataMonitor(data).then(({retData}) => {
            setpagination({
                current: current,
                total: retData.total,
                pageSize: retData.size,
            })
            setSelectInfo({ rowInfo: {}, rowIndex: -1 })
            setList(retData.records)
        })
        transferDataMonitorTotal(data).then(({retData}) => { 
            setotalData(retData)
        })
        setLoading(false)
    }
    //分页事件 置空当前行信息
    const onTableChange = async (page, filters, sorter) => {
        setpagination({
            ...pagination,
            current: page.current,
        })
        loadData(page.current, searchValue)
    }

    const handleExport = async () => {
        setLoadingInfo({ loadingVisible: true, txt: t(`statistics.transferDataMonitor.index.快速导出中`) });
        try {
            const searchParams = {
                shopId,
                shopCode,
                ...searchValue,
                pageSize: -1,
                pageNum: 1,
                branchIn: "ci",
                branchOut: "ci"
            }
            let result = await transferDataMonitorExport(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            console.log(result)
           // debugger
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }

    //列表button
    // const topButtons = [
    //     {
    //         click: () => handleExport(),
    //         content: "导出",
    //     },
    // ]

    //列表button
    const topButtons = <>
    <Button
        className="btn-item"
        shape="round"
        onClick={() => handleExport()}
    > {t(`statistics.transferDataMonitor.index.导出`)}</Button>
</>
    //table配置
    const columns = [
        {
            align: "center",
            width: 60,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.序号`),
            render: (v, r, i) => i + 1
        },
        {
            align: "center",
            width: 200,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.调拨单号`),
            dataIndex: 'code',
        },
        {
            align: "center",
            width: 200,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.单据类型`),
            dataIndex: 'typeName',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.调拨单状态`),
            dataIndex: 'allotStatus',
            render: text => getTreeNodeName(text)
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.调入门店`),
            dataIndex: 'shopName',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.调出门店`),
            dataIndex: 'outShopName',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.调拨数量`),
            dataIndex: 'totalNum',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.调拨金额`),
            dataIndex: 'totalAmount',
        },
        {
            align: "center",
            width: 200,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.调拨成本金额`),
            dataIndex: 'costAmount',
            render: text => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        },
        {
            align: "center",
            width: 200,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.调拨毛利金额`),
            dataIndex: 'grossProfit',
            render: text => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        },
        {
            align: "center",
            width: 200,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.业务单据编号`),
            dataIndex: 'saleCode',
        },

        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.单据状态`),
            dataIndex: 'status',
            render: text => getTreeNodeName(text)
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.单据数量`),
            dataIndex: 'saleNum',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.单据金额`),
            dataIndex: 'amount',
            render: text => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        },
        {
            title: t(`statistics.transferDataMonitor.index.单据成本`),
            dataIndex: 'cost',
            render: text => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        },
        {
            title: t(`statistics.transferDataMonitor.index.单据毛利`),
            dataIndex: 'grossProfit',
            render: text => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        },
        {
            title: t(`statistics.transferDataMonitor.index.金额差异`),
            dataIndex: 'amountDifference',
            render: text => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        },
        {
            title: t(`statistics.transferDataMonitor.index.成本差异`),
            dataIndex: 'costDifference',
            render: text => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        },
        {
            title: t(`statistics.transferDataMonitor.index.毛利差异`),
            dataIndex: 'grossProfitDifference',
            render: text => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.数量差异`),
            dataIndex: 'saleVarianceQuantity',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.金额差异`),
            dataIndex: 'saleVarianceAmount',
            render: text => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.成本差异`),
            dataIndex: 'costVarianceAmount',
            render: text => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: t(`statistics.transferDataMonitor.index.毛利差异`),
            dataIndex: 'profitVarianceAmount',
            render: text => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        },
        {
            align: "center",
            width: 160,
            title: t(`statistics.transferDataMonitor.index.调拨单制单日期`),
            dataIndex: 'createTime',
        },
        {
            align: "center",
            width: 160,
            title: t(`statistics.transferDataMonitor.index.调入`)/t(`statistics.transferDataMonitor.index.出日期`),
            dataIndex: 'saleCreateTime',
        },
    ]
    //搜索JSON
    const searchList = {
        normalList: [
            {
                type: "input",
                placeholder: t(`statistics.transferDataMonitor.index.调拨单号`),
                valueName: "code",
            },
            {
                type: "input",
                placeholder: t(`statistics.transferDataMonitor.index.业务单据编号`),
                valueName: "saleCode",
            },
            // {
            //     type: "select",
            //     placeholder: "调出门店",
            //     valueName: "outShopCode",
            //     optionList: () =>
            //     shopList.map((item) =>
            //         ( 
            //         <Option key={item.id} value={item.code}>
            //             {item.name}
            //         </Option>
            //     )),
            // },
            {
                type: "input",
                placeholder: t(`statistics.transferDataMonitor.index.调出门店`),
                valueName: "outShopName",
            },
        ],
    }
    const desc = [
        {
            label: t(`statistics.transferDataMonitor.index.数量差异`),
            value: totalData.num ?? 0,
            color: "green"
        },
        {
            label: t(`statistics.transferDataMonitor.index.金额差异`),
            value: getCurrentCurrencySymbol() + formatNum(totalData.amount ?? 0),
            color: "red"
        },
        {
            label: t(`statistics.transferDataMonitor.index.成本差异`),
            value: getCurrentCurrencySymbol() + formatNum(totalData.cost ?? 0),
            color: "red"
        },
        {
            label: t(`statistics.transferDataMonitor.index.毛利差异`),
            value: getCurrentCurrencySymbol() + formatNum(totalData.grossProfit ?? 0),
            color: "red"
        },

    ]

    return (
        <>
            {state.activeMenu === 'transferDataMonitor' && (
                <>
                    <TopSearch
                        title= {t(`statistics.transferDataMonitor.index.调拨数据监测`)}
                        searchListData={searchList}
                        searchValue={searchValue}
                        setSearchValue={(obj) => setSearchValue(obj)}
                        handleSearch={loadData}
                    />
                    <YhBox title= {t(`statistics.transferDataMonitor.index.调拨数据监测`)} action={topButtons} descriptions={desc} style={{marginTop:20}}>
                        <Table
                            loading={loading}
                            columns={columns}
                            dataSource={list}
                            pagination={{
                                ...pagination,
                                position: ['bottomCenter'],
                                showTotal: () => `${t(`statistics.transferDataMonitor.index.共`)}${pagination.total}${t(`statistics.transferDataMonitor.index.条`)}`,
                                onChange: (current, serach = searchValue) => {
                                    setSearchValue({...searchValue,pageSize:serach})
                                    loadData(current, searchValue)
                                },
                            }}
                            scroll={{ x: 'max-content' }}
                        />
                    </YhBox>
                </>
            )}
        </>
    )
}
